<template>
  <div class="page">
    <el-form label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="关键字:">
            <el-input v-model="queryForm.Keyword" placeholder="请输入租户名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态：">
            <el-select v-model="queryForm.IsActive">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="true" label="正常"></el-option>
              <el-option :value="false" label="禁用"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="search">筛选</el-button>
          <el-button @click="empty">重置</el-button>
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <el-table ref="table" :data="tenantList" highlight-current-row v-loading="tableLoading"
      @current-change="selectCurrentRow" style="width: 100%" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="name" label="租户名" min-width="100" align="center"></el-table-column>
      <el-table-column prop="tenancyName" label="租户英文名" min-width="100" align="center"></el-table-column>
      <!-- <el-table-column
            prop="adminEmailAddress"
            label="邮箱"
            min-width="180"
            align="center"
          ></el-table-column> -->
      <el-table-column prop="isActive" label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive ? 'success' : 'danger'" disable-transitions>{{ scope.row.isActive ? "正常"
            : "禁用"
            }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="queryForm.pageIndex" :pageSize="queryForm.pageSize" @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="tenantFormVisible" v-if="tenantFormVisible"
      v-model="tenantFormVisible" :close-on-click-modal="false">
      <el-form :model="tenantForm" label-width="120px" :rules="tenantFormRules" ref="tenantForm">
        <el-form-item label="租户名" prop="name">
          <el-input v-model="tenantForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="租户英文名" prop="tenancyName">
          <el-input v-model="tenantForm.tenancyName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="adminEmailAddress" v-if="isEdit == false">
          <el-input v-model="tenantForm.adminEmailAddress"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber" v-if="isEdit == false">
          <el-input v-model="tenantForm.phoneNumber"></el-input>
        </el-form-item>
        <el-form-item v-if="!isEdit" label="登录密码" prop="password">
          <el-input v-model="tenantForm.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="isActive">
          <el-select v-model="tenantForm.isActive">
            <el-option label="正常" :value="true"></el-option>
            <el-option label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="tenantFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitTenant" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配权限" :visible.sync="setPermissionsDialog" v-if="setPermissionsDialog"
      v-model="setPermissionsDialog" :close-on-click-modal="false">
      <el-tree :data="permissionsList" show-checkbox node-key="id" ref="tree" highlight-current :props="defaultProps">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="setPermissionsDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitPermissions" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="changePsdDialog" v-if="changePsdDialog" v-model="changePsdDialog"
      :close-on-click-modal="false">
      <el-form :model="changePsdForm" label-width="120px" :rules="changePsdFormRules" ref="changePsdForm">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="changePsdForm.newPassword" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="changePsdDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitChangePsd" :loading="submitLoading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="权限同步" :visible.sync="asyncDialog" v-if="asyncDialog" :close-on-click-modal="false">
      <el-form label-width="150px">
        <el-form-item label="此次更新权限的租户" v-if="!asyncData.updateAll">
          <el-input :disabled="true" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea" v-model="users"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否更新所有租户">
          <el-radio-group v-model="asyncData.updateAll">
            <el-radio :label=false>否</el-radio>
            <el-radio :label=true>是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板选择">
          <el-select v-model="asyncData.templateId" placeholder="请选择">
            <el-option v-for="item in templateArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="cancelbatchSet">取消</el-button>
        <el-button type="primary" @click.native="batchSet" :loading="submitLoading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAllTenant,
  CreateTenant,
  GetTenantDetail,
  UpdateTenant,
  DeleteTenant,
  GetMenuTree,
  TenantGetPermissions,
  TenantSetPermissions,
  ChangeTenantPsd,
  TenantPermissionTemplateGetAll, UpdatePermissionsFromTemplate
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";

export default {
  components: { toolbar },
  data() {
    const validatePwd = (rule, value, callback) => {
      if (!/^\w{8,16}$/.test(value)) {
        callback(new Error('密码长度8到16位，只能包含字母、数字和下划线'))
      }
      callback()
    }
    return {
      buttonList_toolBar: [],

      tenantList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      queryForm: {
        Keyword: null,
        IsActive: null,
        pageIndex: 1,
        pageSize: 10
      },

      tenantFormVisible: false,
      isEdit: false,
      tenantForm: {
        name: null,
        tenancyName: null,
        adminEmailAddress: null,
        phoneNumber: null,
        isActive: true,
        password: null
      },
      tenantFormRules: {
        name: [
          { required: true, message: '请输入租户名', trigger: 'blur' },
          { message: '请输入租户名', trigger: ['blur', 'change'] }
        ],
        tenancyName: [
          { required: true, message: '请输入租户英文名', trigger: 'blur' },
          { message: '请输入租户英文名', trigger: ['blur', 'change'] }
        ],
        adminEmailAddress: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { trigger: ['blur', 'change'], validator: validatePwd, }
        ]
      },
      submitLoading: false,
      asyncDialog: false,
      userIds: [],
      users: [].toString(),
      setPermissionsDialog: false,
      permissionsList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },

      changePsdDialog: false,
      changePsdForm: {
        tenantId: null,
        newPassword: null
      },
      changePsdFormRules: {
        newPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { trigger: ['blur', 'change'], validator: validatePwd, }
        ]
      },
      asyncData: {
        updateAll: false,
        templateId: null
      },
      searchData: {
        PageIndex: 1, //页码
        PageSize: 100, //页长
      },
      templateArr: [],
    };
  },
  mounted() {
    this.getTenantList();
    this.getpermissionsList();
    this.renderButton();
  },
  created() {
    this.getTableList();
  },
  methods: {
    async getTableList(searchData) {
      // this.loading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await TenantPermissionTemplateGetAll(this.searchData);
      if (res.data.success) {

        let previlieeges = res.data.result.items.map((item) => {
          return { id: item.id, name: item.name }
        })
        this.templateArr = previlieeges;
        console.log('权限列表', previlieeges);
        // this.listLoading = false;
        // this.total = res.data.result.totalCount;
        // this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.error.message || '获取权限模板失败, 请重试');
      }

    },
    cancelbatchSet() {
      this.asyncDialog = false;
      this.asyncData.updateAll = false;
      this.asyncData.templateId = null;
      this.userIds = []
      this.users = '';
      this.$refs.table.clearSelection();
    },
    batchSet() {
      let that = this;
      console.log(this.asyncData)
      console.log(this.userIds)
      if (this.asyncData.updateAll) {
        this.$confirm("确认更新全部租户权限？", "提示", {
          closeOnClickModal: false,
        }).then(async () => {
          let res = UpdatePermissionsFromTemplate({
            templateId: this.asyncData.templateId,
            updateAll: this.asyncData.updateAll, tenantIds: this.userIds
          });

          if (res.data.success) {
            this.asyncDialog = false;
            this.asyncData.updateAll = false;
            this.asyncData.templateId = null;
            this.userIds = []
            this.users = '';
            this.$refs.table.clearSelection();
            await this.getTableList();
            this.$message.success(res.data.message || '更新成功')
          } else {
            this.$message.error(res.data.error.message || '更新失败, 请重试')
          }
          console.log('-*----', res)
        }).catch(() => {
        });
      }

      this.$confirm("确认更新所选租户权限？", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        if (!this.userIds.length) {
          return this.$message.error('请选择更新权限的租户')
        }
        if (!this.asyncData.templateId) {
          return this.$message.error('请选择权限模板')
        }
        // if (!this.asyncData.templateId){
        //   return this.$message.error('请选择权限模板')
        // }
        let res = await UpdatePermissionsFromTemplate({
          templateId: this.asyncData.templateId,
          updateAll: this.asyncData.updateAll, tenantIds: this.userIds
        });

        console.log('-*----', res)
        if (res.data.success) {
          this.$message.success(res.data.message || '更新成功')
          this.asyncData.updateAll = false;
          this.asyncData.templateId = null;
          this.userIds = []
          this.users = '';
          this.asyncDialog = false;
          this.$refs.table.clearSelection();
          await this.getTableList();

        } else {
          this.$message.error(res.data.error.message || '更新失败, 请重试')
        }
      }).catch(() => {
      });
    },
    handleSelectionChange(val) {
      this.userIds = val.map(user => user.id) || [];
      let users = val.map(user => user.name)
      console.log(users)
      this.users = users.join(',')

    },
    synPermissions() {
      console.log('async')
      this.asyncDialog = true;
    },
    changePsd() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要修改的一行数据！');
      }
      this.changePsdDialog = true;
      this.changePsdForm.tenantId = row.id;
      this.changePsdForm.newPassword = null;
    },
    submitChangePsd() {
      let that = this;
      that.$refs.changePsdForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            ChangeTenantPsd(that.changePsdForm).then((res) => {
              that.submitLoading = false;
              that.changePsdDialog = false;
              if (res.data.success) {
                that.$message.success('修改成功');
                that.getTenantList();
              } else {
                that.$message.error(res.data.error.message)
              }
            });
          }).catch(() => {
          });
        }
      });
    },
    renderButton() {
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getTenantList() {
      this.tableLoading = true;
      let params = {
        Keyword: this.queryForm.Keyword,
        IsActive: this.queryForm.IsActive,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllTenant(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.tenantList = res.data.result.items;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getTenantList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getTenantList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTenantList();
    },
    empty() {
      this.queryForm.Keyword = null;
      this.queryForm.IsActive = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTenantList();
    },
    addTenant() {
      this.tenantFormVisible = true;
      this.isEdit = false;
      this.tenantForm = {
        name: null,
        tenancyName: null,
        adminEmailAddress: null,
        phoneNumber: null,
        isActive: true,
        password: null
      }
    },
    editTenant() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetTenantDetail(params).then((res) => {
        if (res.data.success) {
          that.tenantForm = res.data.result;
          that.isEdit = true;
          that.tenantFormVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    delTenant() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        let that = this;
        DeleteTenant(params).then((res) => {
          that.tableLoading = false;
          if (res.data.success) {
            that.$message.success('删除成功');
            that.getTenantList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
      });
    },
    submitTenant() {
      let that = this;
      that.$refs.tenantForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            if (!that.isEdit) {
              CreateTenant(that.tenantForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.tenantFormVisible = false;
                  that.getTenantList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateTenant(that.tenantForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.tenantFormVisible = false;
                  that.getTenantList();
                } else {
                  that.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => {
          });
        }
      });
    },
    getpermissionsList() {
      GetMenuTree().then((res) => {
        this.permissionsList = this.loopMenuTree([res.data.result])[0].children;
        let test = this.permissionsList;
        console.log('permissionsList', this.permissionsList);
        let test2 = 1;
      });
    },
    // 递归封装菜单树
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        if (!item.data.Id) {
          item.id = 0 + '',
            item.label = '根节点'
        } else {
          item.id = item.data.Id + '';
          item.label = item.data.DisplayName;
        }
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    defaultChecked(menus) { // 默认选中
      this.$nextTick(() => {
        const arr = []
        menus.forEach(item => {
          if (this.$refs.tree.getNode(item.name)) {
            if (!this.$refs.tree.getNode(item.name).childNodes || !this.$refs.tree.getNode(item.name).childNodes.length) {
              arr.push(item.name)
            }
          }
          // try {
          //   if (!this.$refs.tree.getNode(item.name).childNodes || !this.$refs.tree.getNode(item.name).childNodes.length) {
          //     arr.push(item.name)
          //   }
          // } catch(e) {
          //   debugger
          //   let test = item;
          // }
        })
        this.$refs.tree.setCheckedKeys(arr)
      })
    },
    setPermissions() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择一行数据！');
      }
      let params = { tenantId: row.id };
      let that = this;
      TenantGetPermissions(params).then((res) => {
        console.log('res===========', res)
        if (res.data.success) {
          that.setPermissionsDialog = true;
          // let permissionList = [];
          // res.data.result.forEach(o => {
          //   permissionList.push((o.name));
          // })
          that.defaultChecked(res.data.result);


          // that.$nextTick(() => {
          //   that.setCheckedKeys(permissionList);
          // });
        } else {
          that.$message.error(res.data.msg);
        }
      });

      // let params = { Id: row.id };
      // let that = this;
      // GetRoleDetail(params).then((res) => {
      //   if (res.data.success) {
      //     that.roleForm = res.data.result;
      //     that.setPermissionsDialog = true;
      //     that.$nextTick(() => {
      //       that.setCheckedKeys(that.roleForm.grantedPermissions);
      //     });
      //   } else {
      //     that.$message.error(res.data.msg);
      //   }
      // });
    },
    submitPermissions() {
      this.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(() => {

        let test1 = this.$refs.tree.getCheckedNodes();
        let test2 = this.$refs.tree.getCheckedNodes(false, true);
        let test3 = this.getCheckedKeys();

        // let params = {
        //   tenantId: this.currentRow.id,
        //   permissions: this.getCheckedKeys()
        // };


        let checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
        let checkedIds = [];
        checkedNodes.forEach(o => {
          checkedIds.push((o.id));
        })

        let params = {
          tenantId: this.currentRow.id,
          permissions: checkedIds
        };

        let that = this;
        TenantSetPermissions(params).then((res) => {
          that.submitLoading = false;
          if (res.data.success) {
            that.$message.success('提交成功');
            that.setPermissionsDialog = false;
          } else {
            that.$message.error(res.data.error.message)
          }
        });


        // this.roleForm.grantedPermissions = this.getCheckedKeys();
        // let that = this;
        // UpdateRole(that.roleForm).then((res) => {
        //   that.submitLoading = false;
        //   if (res.data.success) {
        //     that.$message.success('提交成功');
        //     that.setPermissionsDialog = false;
        //   } else {
        //     that.$message.error(res.data.error.message)
        //   }
        // });
      }).catch(() => {
      });
    },
    // 获取选中的key
    getCheckedKeys() {
      return this.$refs.tree.getCheckedKeys();
    },
    // 通过设置key选中节点
    setCheckedKeys(keyList) {
      this.$refs.tree.setCheckedKeys(keyList);
    }
  }
};
</script>
<style scoped>
/* #main-box {
  width: 100%;
  height: 100%;
  padding-top: 90px;
}

#btn-box {
  position: fixed;
  height: 110px;
  top: 94px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-top: 5px;
}

#btn-box /deep/ .el-form-item {
  margin-bottom: 10px;
}

#content-box {
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

#main-box /deep/ .el-pagination {
  padding: 10px 5px;
} */
</style>
